module.exports = __webpack_public_path__ + "static/media/arrow-down.4e949ab6.svg";